import AddressDto from "./AddressDto";
import CategoryDto from "./CategoryDto";
import CurrencyDto from "./CurrencyDto";
import LanguageDto from "./LanguageDto";
import LicenseDto from "./LicenseDto";
import OpeningDayDto from "./OpeningDayDto";
import QRMenuPropertiesDto from "./QRMenuPropertiesDto";
import SocialMediaDto from "./SocialMediaDto";
import TableDto from "./TableDto";

export default class RestaurantDto {
    id: number;
    name: string;
    address: AddressDto;
    currency: CurrencyDto;
    license: LicenseDto;
    categories: CategoryDto[];
    languages: LanguageDto[];
    imageUrl: string;
    email: string;
    openingDays: OpeningDayDto[];
    qrMenuProperties: QRMenuPropertiesDto;
    socialMedia: SocialMediaDto;
    tables: TableDto[];
    constructor(id: number, name: string, address: AddressDto, currency: CurrencyDto, license: LicenseDto, categories: CategoryDto[], languages: LanguageDto[], openingDays: OpeningDayDto[], imageUrl: string, email: string, qrMenuProperties: QRMenuPropertiesDto, socialMedia: SocialMediaDto, tables: TableDto[]) {
        this.id = id;
        this.name = name;
        this.address = address;
        this.currency = currency;
        this.license = license;
        this.categories = categories;
        this.languages = languages;
        this.openingDays = openingDays;
        this.imageUrl = imageUrl;
        this.email = email;
        this.qrMenuProperties = qrMenuProperties;
        this.socialMedia = socialMedia;
        this.tables = tables;
    }
}